import { formatPercent } from './formattingUtils';

export const formatSharePercent = (percent) => formatPercent(Number(percent.toFixed(2)));

export const poolShareOfGross = (earnings) => {
  const pool = earnings?.poolAmount || 0;
  const gross = earnings?.grossPotential || 0;
  if (!(pool > 0)) return null;
  if (!(gross > 0)) return null;
  return (pool / gross) * 100;
};

export const describeSalesReached = (earnings, { settled = false } = {}) => {
  const sales = `at ${settled ? 'settled' : 'projected'} sales`;
  const bracket = earnings?.dealBracketReached;
  if (!bracket) return sales;
  return `${sales}, in tier ${bracket.number} of ${bracket.bracketCount}`;
};

export const describePoolShareOfGross = (earnings, { formatAmount, settled = false }) => {
  const percent = poolShareOfGross(earnings);
  if (percent === null) return null;
  const gross = formatAmount(earnings.grossPotential);
  return `${formatSharePercent(percent)} of ${gross} gross ${describeSalesReached(earnings, { settled })}`;
};

export const describeTakeShares = (take, earnings) => {
  if (poolShareOfGross(earnings) === null) return null;
  const ofPool = formatSharePercent((take / earnings.poolAmount) * 100);
  const ofGross = formatSharePercent((take / earnings.grossPotential) * 100);
  return `${ofPool} of pool = ${ofGross} of gross`;
};
